/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBaseChartItemListViewmodelGen,
  MrfiktivBaseTrendAnalysisViewmodelGen,
  MrfiktivFleetAnalyticsControllerCoverageTypeAverageParamsGen,
  MrfiktivFleetAnalyticsControllerCoverageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerDamageTypeAverageParamsGen,
  MrfiktivFleetAnalyticsControllerDamageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByCoverageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByDamageTypeParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByInvoiceSellerParamsGen,
  MrfiktivFleetAnalyticsControllerGetTotalSubtotalByVehicleParamsGen,
  MrfiktivFleetAnalyticsControllerReportWeekdayAnalysisPerPartnerParamsGen,
  MrfiktivFleetAnalyticsControllerStatusDistributionParamsGen,
  MrfiktivFleetAnalyticsControllerTrendAnalysisForPartnerParamsGen,
  MrfiktivFleetAnalyticsControllerTripTypeParamsGen,
  MrfiktivInvoiceChartItemListViewModelGen,
  MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen,
  MrfiktivStatusDistributionAnalyticsViewModelGen
} from "./data-contracts";
import { HttpClient, RequestParams } from "./http-client";

export class FleetAnalytics<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByDamageType
   * @summary Get sub total per damage type by partner id and time range
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/damage-type
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByDamageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByDamageTypeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/damage-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByCoverageType
   * @summary Get sub total per coverage type by partner id and time range
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/coverage-type
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByCoverageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByCoverageTypeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/coverage-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerTripType
   * @summary Returns the aggregation of trip types
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/trip-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the trip type
   */
  fleetAnalyticsControllerTripType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerTripTypeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/trip-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerCoverageType
   * @summary Returns the aggregation of coverage types
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/coverage-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the coverage type
   */
  fleetAnalyticsControllerCoverageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerCoverageTypeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/coverage-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerDamageType
   * @summary Returns the aggregation of damage types
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/damage-type
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Distribution of the damage type
   */
  fleetAnalyticsControllerDamageType = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerDamageTypeParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/damage-type`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerDamageTypeAverage
   * @summary Returns the average total of damage types
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/damage-type-average
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Average total of the damage type
   */
  fleetAnalyticsControllerDamageTypeAverage = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerDamageTypeAverageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/damage-type-average`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerCoverageTypeAverage
   * @summary Returns the average total of coverage types
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/coverage-type-average
   * @secure
   * @response `200` `MrfiktivBaseChartItemListViewmodelGen` Average total of the coverage type
   */
  fleetAnalyticsControllerCoverageTypeAverage = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerCoverageTypeAverageParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseChartItemListViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/coverage-type-average`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByInvoiceSeller
   * @summary Get inbound sub total per inoice seller
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/invoice/seller
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByInvoiceSeller = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByInvoiceSellerParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/invoice/seller`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerStatusDistribution
   * @summary Returns the aggregation of status distribution
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/status-distribution
   * @secure
   * @response `200` `MrfiktivStatusDistributionAnalyticsViewModelGen` Distribution of the impact type
   */
  fleetAnalyticsControllerStatusDistribution = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerStatusDistributionParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivStatusDistributionAnalyticsViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/status-distribution`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerReportWeekdayAnalysisPerPartner
   * @summary Returns the aggregation of reports on a weekly basis.
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/weekday-analysis
   * @secure
   * @response `200` `MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen` Distribution of report per weekday
   */
  fleetAnalyticsControllerReportWeekdayAnalysisPerPartner = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerReportWeekdayAnalysisPerPartnerParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivReportWeeklyAnalysisPerPartnerViewmodelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/weekday-analysis`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerTrendAnalysisForPartner
   * @summary Return partner trendanalysis for day, week and 30 days
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/trend
   * @secure
   * @response `200` `MrfiktivBaseTrendAnalysisViewmodelGen` Report trend data
   * @response `400` `void` General error if request is not working.
   */
  fleetAnalyticsControllerTrendAnalysisForPartner = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerTrendAnalysisForPartnerParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivBaseTrendAnalysisViewmodelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/trend`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Analytics
   * @name FleetAnalyticsControllerGetTotalSubtotalByVehicle
   * @summary Get inbound sub total per vehicle
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/analytics/vehicle
   * @secure
   * @response `200` `MrfiktivInvoiceChartItemListViewModelGen` The found record
   * @response `403` `void` Forbidden.
   */
  fleetAnalyticsControllerGetTotalSubtotalByVehicle = (
    { partnerId, fleetId, ...query }: MrfiktivFleetAnalyticsControllerGetTotalSubtotalByVehicleParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceChartItemListViewModelGen, void>({
      path: `/partner/${partnerId}/fleet/${fleetId}/analytics/vehicle`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
}
